<template>
  <VLoader v-if="loading" />
  <section v-else class="shared-section">
    <header class="shared-section-header">
      <h2 class="pl-4 shared-section-header-heading sm:pl-0">{{ $t('orders.header.heading') }}</h2>
    </header>
    <div
      v-for="order in orders"
      :key="order.id"
      class="mb-6 overflow-hidden sm:border sm:rounded sm:border-ricoma-gray-300"
    >
      <Order :order="order" />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import VLoader from '@/components/base/VLoader';
import Order from '@/components/customer/Order';

export default {
  name: 'orders',
  components: { Order, VLoader },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      orders: state => state.customer.orders,
    }),
  },
  methods: {
    async setOrders() {
      this.loading = true;
      await this.$store.dispatch('customer/getOrders');
      this.loading = false;
    },
  },
  mounted() {
    if (!this.orders.length) {
      this.setOrders();
    }
  },
};
</script>
